import { Reducer } from 'redux';
import { KnownAction, UpdateRolesConstantAction, UpdateGradesConstantAction, UpdateStateConstantAction, KnownConstantStates, UpdateLanguagesConstantAction, UpdateCultureConstantAction, UpdateConfigConstantAction, UpdateCheckpointsConstantAction } from './ConstantActions';
import { Grades } from "src/constants/Grades";
import { Roles } from "src/constants/Roles";
import Languages from "src/constants/Languages";
import Config from "src/constants/Config";
import { Checkpoints } from "src/constants/Checkpoints";

export class ConstantState {
    public Grades: Grades;
    public Roles: Roles;
    public Languages: Languages;
    public Config: Config;

    public state: KnownConstantStates;

    constructor() {
        this.Grades = Grades;
        this.Roles = Roles;
        this.Languages = Languages;
        this.Config = Config;
        this.state = "none";
    }
}

export const ConstantReducer: Reducer<ConstantState> = (state: ConstantState = new ConstantState(), action: KnownAction) => {
    switch (action.type) {
        case "UPDATE_ROLES_CONSTANTS":
            let rolesAction: UpdateRolesConstantAction = action;
            if (rolesAction.data == null) {
                return { ...state };
            }

            for (const item of rolesAction.data) {
                let feels = Roles.All.find(x => x.name === item.key);
                if (feels == null) {
                    continue;
                }
                feels.id = item.value;
            }

            return {
                ...state,
                Roles: Roles
            };
        case "UPDATE_GRADES_CONSTANTS":
            let gradeAction: UpdateGradesConstantAction = action;
            if (gradeAction.data == null) {
                return { ...state };
            }

            for (const item of gradeAction.data) {
                let lives = Grades.All.find(x => x.shortName === item.key);
                if (lives == null) {
                    continue;
                }
                lives.id = item.value;
            }

            return {
                ...state,
                Grades: Grades
            };
        case "UPDATE_CHECKPOINTS_CONSTANTS":
            let checkpointAction: UpdateCheckpointsConstantAction = action;
            if (checkpointAction.data == null) {
                return { ...state };
            }

            for (const item of checkpointAction.data) {
                let lives = Checkpoints.All.find(x => x.name === item.key);
                if (lives == null) {
                    continue;
                }
                lives.id = item.value;
            }

            return {
                ...state,
                Grades: Grades
            };
        case "UPDATE_LANGUAGES_CONSTANTS":
            let languageAction: UpdateLanguagesConstantAction = action;
            if (languageAction.data == null) {
                return { ...state };
            }

            for (const item of languageAction.data) {
                let langs = Languages.All.find(x => x.code === item.key.toLowerCase());
                if (langs == null) {
                    continue;
                }
                langs.id = item.value;
            }

            return {
                ...state,
                Languages: Languages
            };
        case "UPDATE_STATE_CONSTANTS":
            let updateStateAction: UpdateStateConstantAction = action;
            return {
                ...state,
                state: updateStateAction.data
            };
        case "UPDATE_CULTURE_CONSTANTS":
            let updateCultureAction: UpdateCultureConstantAction = action;
            if (updateCultureAction.data == null) {
                return { ...state };
            }
            // Reset all to false as a default
            Languages.All.forEach(x => x.isAvailable = false);

            for (const item of updateCultureAction.data) {
                let langs = Languages.All.find(x => x.code === item.value.toLowerCase());
                if (langs == null) {
                    continue;
                }
                langs.isAvailable = true;
            }

            return {
                ...state,
                Languages: Languages
            };
        case "UPDATE_CONFIG_CONSTANTS":
            let updateConfigAction: UpdateConfigConstantAction = action;
            Config.AzureUrl = updateConfigAction.data.azureBaseUrl;
            Config.AzureKey = updateConfigAction.data.azureKey;

            return {
                ...state,
                Config: Config
            };
        default:
            // JB - Clarification: The following line is fucking magic
            const exhaustiveCheck: never = action;
    }

    // For unrecognized actions (or in cases where actions have no effect), must return the existing state
    //  (or default initial state if none was supplied)
    return state;
};



// WEBPACK FOOTER //
// ./src/redux/ConstantReducer.ts